import { Box, Typography } from "@mui/material";
import { useTheme } from "../../components/context/context";
import District from "./District";
import Block from "./Block";
import Area from "./Area";

export default function SocialAuditResourcePersons(){
    const {fontSize} = useTheme();
    return(
        <Box sx={{}}>
            <Typography variant="h1" sx={{fontSize:`${fontSize+0.5}rem`, margin:"5px 0"}}>Social Audit Resource Persons</Typography>
            <hr/>
            <Box sx={{padding: "2px 0 2px 10px", marginTop: "20px", width:"100%"}}>
                <District/>
                <Block/>
                <Area />
            </Box>
        </Box>
    )
}

